export interface HelpLink {
  url: string;
}

export interface ActionDropdownGroup {
  id: string;
  label?: string;
  links: ActionDropdownItem[];
}

export interface ActionDropdownItem {
  id: string;
  label: string;
  url: string;
  isDisabled: boolean;
  onClickCallback?: () => void;
}

export interface Action {
  id: string;
  type: ACTION_TYPE;
  state?: ACTION_STATE;
  label: string;
  toolTip?: string;
  tooltipPosition?: POSITION;
  ariaLabel?: string;
  isNonInteractiveTooltip?: boolean;
}

export interface PopoverType extends Action {
  content?: string;
  buttonType?: BUTTON_TYPE;
  contentType?: string;
}

export interface ButtonType extends Action {
  onClickEvent: any;
  buttonType?: string;
}

export interface DropdownType extends Action {
  groups?: ActionDropdownGroup[];
}

export type ActionInfo = PopoverType | ButtonType | DropdownType | Action;

export interface Attribute {
  id: string;
  type: string;
  toolTip?: string;
  tooltipPosition?: POSITION;
  ariaLabel?: string;
  isNonInteractiveTooltip?: boolean;
}

export interface KeyValue extends Attribute {
  key: string;
  value: string;
  valueStyle?: string;
  valueUrl?: string;
}

export interface Link extends Attribute {
  label: string;
  url: string;
  openInNewTab?: boolean;
  disabled?: boolean;
}

export interface Toggle extends Attribute {
  isActive?: boolean;
  isDisabled?: boolean;
  eventHandler?: any;
}

export interface Bar extends Attribute {
  label?: string;
  content?: string;
  percentage: number;
  targetLine?: number;
  tooltipText?: Array<string>;
  state?: BAR_STATE;
}
export interface Activation extends Attribute {
  label: string;
  offLabel: string;
  isActive: boolean;
  disabled?: boolean;
  activationAPI: string;
  apiCallFailureMessage: string;
  attachedComponent: string;
  disable?: boolean;
}

export interface TextLinkPopoverRemote extends Attribute {
  label: string;
  content: string;
  popoverAPI: string;
  apiCallFailureMessage: string;
  withCloseButton?: boolean;
}

export interface TextLinkPopover extends Attribute {
  label: string;
  content: string;
  popoverContent: Array<string>;
  withCloseButton?: boolean;
}

export interface PageTitleIconProps {
  id: string;
  isActive?: boolean;
  apiCallFailureMessage: string;
  apiCallSuccessMessage: string;
  iconAPI: string;
  iconStatusAPI?: string;
}

export type AttributeTypes =
  | KeyValue
  | Link
  | Toggle
  | Activation
  | Bar
  | TextLinkPopover
  | TextLinkPopoverRemote;

export enum POSITION {
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left',
}

export enum BAR_STATE {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export enum BAR_STATE_STYLE {
  WARNING = 'warning',
  ERROR = 'error',
  DEFAULT = 'default',
}

export enum ATTRIBUTE_TYPE {
  TOGGLE = 'TOGGLE',
  KEY_VALUE = 'KEY_VALUE',
  LINK = 'LINK',
  BAR = 'BAR',
  ACTIVATION = 'ACTIVATION',
  TEXTLINK_POPOVER = 'TEXTLINK_POPOVER',
  TEXTLINK_POPOVER_REMOTE = 'TEXTLINK_POPOVER_REMOTE',
}

export enum ACTION_TYPE {
  BUTTON = 'BUTTON',
  DROPDOWN = 'DROPDOWN',
  POPOVER = 'POPOVER',
  TEXT = 'TEXT',
}

export function getBarStatus(barState: BAR_STATE) {
  switch (barState) {
    case BAR_STATE.WARNING:
      return BAR_STATE_STYLE.WARNING;
    case BAR_STATE.ERROR:
      return BAR_STATE_STYLE.ERROR;
    case BAR_STATE.SUCCESS:
      return BAR_STATE_STYLE.DEFAULT;
  }
}

export enum VALUE_STYLE {
  SUCCESS = 'SUCCESS',
  INACTIVE = 'INACTIVE',
  DISABLED = 'DISABLED',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}

export enum ACTION_STATE {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  LOADING = 'LOADING',
}

export enum BUTTON_TYPE {
  NORMAL = 'NORMAL',
  PRIMARY = 'PRIMARY',
  LINK = 'LINK',
}

export interface PopoverWithContent {
  headerText?: string;
  list?: Array<string>;
  text?: string;
}

export interface PopoverMultipleLines {
  lines: Array<string>;
}
